import { render, staticRenderFns } from "./ListaTaxaRegulacao.vue?vue&type=template&id=4b3b6358"
import script from "./ListaTaxaRegulacao.vue?vue&type=script&lang=js"
export * from "./ListaTaxaRegulacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports